import { useNavigate, useLocation } from "react-router-dom";
import { HeaderPosition } from "./PageAnimations";
import { PagenumValue, LeftPage, RightPage } from "./Footer";
import { useState, useEffect } from "react";

    /* Try to measure when one of the header buttons is pressed 
     via handleClick, such that when it is retrieved we save
     a numeric value to the "pagenums" variable. Use 
     "getelementbyID" to retrieve the ID from another file.
     EDIT: Instead, I'm using ClassName and a for-loop to 
     iterate through all the artwork names. 
     EDIT 2: I'm making it into a seperate function and 
     adding handleClick to it.
     EDIT 3: Screw it. It's not working this way.
     Instead I'll just use event and currentTarget. */

export let HeaderElement = {
    get GetHeader() {
        return this.HeaderElement;
    },
    /**
     * @param {string} id
     */
    set SetHeader(id) {
        this.HeaderElement = id;
    }
}; 

//export let FooterEnable;
   
function Navbar() {  
return (
    <>
        <Header />
    </>
    );
}

function Header() {
    const [clicked, setClicked] = useState(false); // For recording consecutive button presses.
    console.debug("Value of click default (Header): " + clicked);
    //console.debug("Value of FooterEnable default (Header): " + FooterEnable);
    let HeaderClickValue = HeaderElement.GetHeader;
    console.debug("HeaderClickValue header: " + HeaderClickValue);

    const [clickedsecond, setClickedSecond] = useState({
        artwork: null,
        coding: null,
        writing: null,
        about: null
    }); // For recording consecutive button presses.

    console.debug("Value of click default (Header 2): " 
        + clickedsecond.artwork + ", " 
        + clickedsecond.coding + ", "
        + clickedsecond.writing + ", "
        + clickedsecond.about);

     // Reset buttons back to enabled when pagenums changes outside of clicking header.
     useEffect(() => {
        if ((HeaderClickValue === "N/A")) { 
                /* Issue: Since Writing (11) and About (12) sections are adjacent, 
                the former section's button fails to be enabled when repeatedly clicked and
                the page flips to the latter section. Don't know how to fix now, so I'll 
                leave it be. 
                EDIT: Instead used the Header value which works effectively, as a result of
                initializing its value to N/A every time the footer buttons are invoked.           
                */ 
            console.debug("UseEffect Header Buttons Enabled.");
            setClickedSecond({ 
                artwork: false,
                coding: false,
                writing: false,
                about: false
            });    
        }
  }, [HeaderClickValue]); // UseEffect runs only when pagenum value changes.

    function HeaderClick() {
        let navigate = useNavigate();
        let location = useLocation();

        const handleClick = event => {
            HeaderElement.SetHeader = event.currentTarget.id;
            console.debug("HeaderElement? " + HeaderElement.GetHeader);
            setClicked(true); // Disable button after clicking once to prevent multiple button clicks.
            console.debug("Value of click before (Header): " + clicked);
            //FooterEnable = clicked;     
           // console.debug("Value of FooterEnable before (Header): " + FooterEnable);
                    
            setClickedSecond({ 
                artwork: true,
                coding: true,
                writing: true,
                about: true
            });                   
            console.debug("Value of click before (Header 2): " 
                + clickedsecond.artwork + ", " 
                + clickedsecond.coding + ", "
                + clickedsecond.writing + ", "
                + clickedsecond.about);


            // Changed from If-Else to Switch (may use ternary later)
            switch(HeaderElement.GetHeader) {
                case "BoA-header-artwork": 
                    if (location.pathname === "/artwork") {
                      /* Decided instead to set disabled button upon click event.   
                      setClickedSecond(previousState => {
                            return { ...previousState, 
                                artwork: true,
                                coding: false,
                                writing: false,
                                about: false }
                        });  */                       
                        console.debug("Value of click duplicate (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);

                        console.debug("Pagenum Value duplicate: " + PagenumValue);
                    } else {   
                        LeftPage.SetPage = 4;
                        RightPage.SetPage = 5;
                        console.debug("Pagenum Value non-duplicate: " + PagenumValue);
                        HeaderPosition(HeaderElement.GetHeader, PagenumValue);
                        setTimeout(() => {
                            navigate("/artwork");
                            setClicked(false);
                            console.debug("Value of click after (Header): " + clicked);
                            //console.debug("Value of FooterEnable after (Header): " + FooterEnable);
                            setClickedSecond({ 
                                artwork: true,
                                coding: false,
                                writing: false,
                                about: false
                            });
                            console.debug("Value of click after (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);
                        }, 1000);
                    };
                    break;
                case "BoA-header-coding-projects": 
                    if (location.pathname === "/codingprojects") {
                      /* Decided instead to set disabled button upon click event.      
                        setClickedSecond(previousState => {
                            return { ...previousState, 
                                artwork: false, 
                                coding: true,
                                writing: false,
                                about: false }
                        });  */
                        console.debug("Value of click duplicate (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);

                        console.debug("Pagenum Value duplicate: " + PagenumValue);
                    } else { 
                        LeftPage.SetPage = 10;
                        RightPage.SetPage = 11;
                        HeaderPosition(HeaderElement.GetHeader, PagenumValue);
                        setTimeout(() => {
                            navigate("/codingprojects");
                            setClicked(false);
                            console.debug("Value of click after (Header): " + clicked);
                            setClickedSecond({ 
                                artwork: false,
                                coding: true,
                                writing: false,
                                about: false
                            });
                            console.debug("Value of click after (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);
                        }, 1000);
                    }; 
                    break;
                case "BoA-header-writing": 
                    if (location.pathname === "/writing") {
                    /* Decided instead to set disabled button upon click event.      
                       setClickedSecond(previousState => {
                            return { ...previousState, 
                                artwork: false, 
                                coding: false,
                                writing: true,
                                about: false }
                        });  */                    
                         console.debug("Value of click duplicate (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);

                        console.debug("Pagenum Value duplicate: " + PagenumValue);
                    } else {  
                        LeftPage.SetPage = 20;
                        RightPage.SetPage = 21;
                        HeaderPosition(HeaderElement.GetHeader, PagenumValue);
                        setTimeout(() => {
                            navigate("/writing");
                            setClicked(false);
                            console.debug("Value of click after (Header): " + clicked);
                            setClickedSecond({ 
                                artwork: false,
                                coding: false,
                                writing: true,
                                about: false
                            });
                            console.debug("Value of click after (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);
                        }, 1000);
                    };
                    break;
                case "BoA-header-about": 
                    if (location.pathname === "/about") {
                    /* Decided instead to set disabled button upon click event.      
                        setClickedSecond(previousState => {
                            return { ...previousState, 
                                artwork: false,
                                coding: false,
                                writing: false,
                                about: true }
                        }); */                         
                        console.debug("Value of click duplicate (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);
                    } else { 
                        LeftPage.SetPage = 22;
                        RightPage.SetPage = 23; 
                        HeaderPosition(HeaderElement.GetHeader, PagenumValue);
                        setTimeout(() => {
                            navigate("/about");
                            setClicked(false);
                            console.debug("Value of click after (Header): " + clicked);
                            setClickedSecond({ 
                                artwork: false,
                                coding: false,
                                writing: false,
                                about: true
                            });
                            console.debug("Value of click after (Header 2): " 
                                + clickedsecond.artwork + ", " 
                                + clickedsecond.coding + ", "
                                + clickedsecond.writing + ", "
                                + clickedsecond.about);
                        }, 1000);
                    };
                    break;
                case "BoA-header-logo":
                    LeftPage.SetPage = 0;
                    RightPage.SetPage = 0;
                    HeaderPosition(HeaderElement.GetHeader, PagenumValue);
                    setTimeout(() => {
                        navigate("/");
                        setClicked(false);
                        setClickedSecond({ 
                            artwork: false,
                            coding: false,
                            writing: false,
                            about: false
                        });
                    }, 1500); 
                    break;
                default: 
                    return HeaderElement.GetHeader;         
                }
        };
            return handleClick;    
    }

  return (
    <header className="Book-of-Abdul-Header">
        {/* <div className="Book-of-Abdul-Bookmark-Header">  */}
            <div className="BoA-Buttons-Header"> 
                {/*<figure className="BoA-Button-Decorations">
                     <img id="BoA-button-dec-header" src={ButtonDecorationHeader} alt={headdecor.title}/> 
                </figure>*/}
           
                <nav id="BoA-button-layout-header">
                    <button onClick={HeaderClick()}
                        disabled={clickedsecond.artwork} 
                        className="BoA-header-buttons" 
                        id="BoA-header-artwork"
                        type="button"
                        title="Artwork">
                        Artwork
                    </button>

                    <button onClick={HeaderClick()}
                        disabled={clickedsecond.coding} 
                        className="BoA-header-buttons" 
                        id="BoA-header-coding-projects"
                        type="button"
                        title="Coding Projects">
                        Coding Projects
                    </button>

                    <button onClick={HeaderClick()}
                        disabled={clickedsecond.writing} 
                        className="BoA-header-buttons" 
                        id="BoA-header-writing"
                        type="button"
                        title="Writing">
                        Writing
                    </button>

                    <button onClick={HeaderClick()}
                        disabled={clickedsecond.about} 
                        className="BoA-header-buttons" 
                        id="BoA-header-about"
                        type="button"
                        title="About">
                        About
                    </button>
                </nav>
            </div>
           
            <div className="BoA-Header-Logo-Button">
                <button onClick={HeaderClick()}
                    disabled={clicked}
                    id="BoA-header-logo" 
                    type="button"
                    title="Return to Homepage">
                </button>
            </div>
        {/* </div> */}
    </header>
    );
}

export default Navbar;    

/*Omitting const due to changes in my header button from an <img> to a <button>. 
    const frontlogo = 
        {
            title: "BookofAbdulFrontLogo",
            photo: BookofAbdulFrontLogo
        };
    */